export function convertDateFormat(dateString) {
  // Split the date string into year, month, and day
  const [year, month, day] = dateString.split("-");

  // Concatenate the parts together in the desired format
  const formattedDate = year + month + day;

  // Return the formatted date
  return formattedDate;
}